import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import styled from 'styled-components';
import { KEYS } from '../../../constants/keys.js';
import { useTranslations } from '../../../hooks/use_translations.js';
import { spacing2x, spacing1x } from '../../../styles/spacing.js';
import { useThemeContext } from '../../../styles/themes/themes.js';
import { A2E_DATA_TESTIDS } from '../constants.js';
import { jsx } from 'react/jsx-runtime';

var ReadViewContainer = styled.div.withConfig({
  displayName: "ActivateToEditReadView__ReadViewContainer",
  componentId: "sc-1str2b-0"
})(["&&{padding:", ";border-radius:", ";color:", ";min-height:32px;font-style:normal;", ";}&& :hover{background-color:", ";}"], spacing2x, spacing1x, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralColors.smoke;
}, function (props) {
  if (props.hasPlaceholder) {
    return "font-style: italic;";
  }
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.neutralColors.porcelain;
});
var ReadViewContainerReadOnly = styled(ReadViewContainer).withConfig({
  displayName: "ActivateToEditReadView__ReadViewContainerReadOnly",
  componentId: "sc-1str2b-1"
})(["&&{cursor:not-allowed;}"]);
var ReadViewContainerDisabled = styled(ReadViewContainer).withConfig({
  displayName: "ActivateToEditReadView__ReadViewContainerDisabled",
  componentId: "sc-1str2b-2"
})(["&&{opacity:0.5;cursor:not-allowed;color:", ";border:1px solid ", ";background-color:", ";border-radius:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.neutralColors.rhino;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.neutralColors.silver;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.neutralColors.pearl;
}, spacing1x);
var ActivateToEditReadView = function ActivateToEditReadView(_ref6) {
  var ariaLabelPrefix = _ref6.ariaLabelPrefix,
    disabled = _ref6.disabled,
    hasPlaceholder = _ref6.hasPlaceholder,
    onBlur = _ref6.onBlur,
    onStartEdit = _ref6.onStartEdit,
    readOnly = _ref6.readOnly,
    readRef = _ref6.readRef,
    readView = _ref6.readView;
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var _React$useState = React.useState(t("ActivateToEdit.instructions")),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    label = _React$useState2[0],
    setLabel = _React$useState2[1];
  React.useLayoutEffect(function () {
    var _readRef$current;
    var finalLabel = ariaLabelPrefix ? "".concat(ariaLabelPrefix, ". ") : "";
    finalLabel += "".concat((_readRef$current = readRef.current) === null || _readRef$current === void 0 ? void 0 : _readRef$current.innerText, ". ").concat(t("ActivateToEdit.instructions"));
    setLabel(finalLabel);
  }, [ariaLabelPrefix, readRef]);
  var onReadViewKeyDown = function onReadViewKeyDown(event) {
    switch (event.key) {
      case KEYS.SPACE:
      case KEYS.ENTER:
        event.stopPropagation();
        event.preventDefault();
        onStartEdit();
        break;
    }
  };
  var onStartEditHandler = function onStartEditHandler(event) {
    event.stopPropagation();
    onStartEdit();
  };
  if (readOnly) {
    return /*#__PURE__*/jsx(ReadViewContainerReadOnly, {
      tabIndex: 0,
      "aria-label": label,
      children: readView
    });
  } else if (disabled) {
    return /*#__PURE__*/jsx(ReadViewContainerDisabled, {
      children: readView
    });
  } else {
    return /*#__PURE__*/jsx(ReadViewContainer, {
      onBlur: onBlur,
      onKeyDown: onReadViewKeyDown,
      onClick: onStartEditHandler,
      hasPlaceholder: hasPlaceholder,
      tabIndex: 0,
      ref: readRef,
      "aria-label": label,
      "data-testid": A2E_DATA_TESTIDS.readViewContainer,
      children: readView
    });
  }
};
ActivateToEditReadView.displayName = "ActivateToEditReadView";

export { ActivateToEditReadView };
